import { LCS_API_CONFIG } from '@lcs/shared/api';
import { FileService } from '@lcs/shared/attachments';
import { LcsScreensizeBreakpointsService } from '@lcs/shared/breakpoints';
import { environment } from 'src/environments/environment';

export const LcsProviders = [
   { provide: LCS_API_CONFIG, useValue: environment.apiConfig },
   FileService,
   LcsScreensizeBreakpointsService,
];
